import type React from 'react'

export function InformativeBanner(props: { title?: string; text: string | React.ReactNode; inlineIcon?: boolean }) {
  const icon = <i className={`pi pi-info-circle h-[20px] w-[20px] content-center text-2xl text-[#0047BB]`} />
  return (
    <div className='rounded-[8px] border-[1px] border-[#0047BB] bg-[var(--informative-disclaimer-background)] p-[16px]'>
      {(props.title || typeof props.inlineIcon === 'undefined' || !props.inlineIcon) && (
        <div className='mb-[10px] flex flex-row items-center justify-start'>
          {(typeof props.inlineIcon === 'undefined' || !props.inlineIcon) && icon}

          {props.title && (
            <div className='col-span-11 col-start-1 pl-[26px] text-[16px] font-bold leading-[22px] text-[#4A4A4A]'>
              {props.title}
            </div>
          )}
        </div>
      )}
      <div className='flex text-justify text-[13px] font-normal leading-[16px] text-[#4A4A4A]'>
        {typeof props.inlineIcon !== 'undefined' && props.inlineIcon && icon}
        <div className={typeof props.inlineIcon !== 'undefined' && props.inlineIcon ? 'ml-3 text-left' : 'text-left'}>
          {props.text}
        </div>
      </div>
    </div>
  )
}
